module.exports = __webpack_public_path__ + "public-ui/img/phone.a7c884c0.svg";